import React, { forwardRef } from 'react';
import styles from './SegmentedButtons.module.css';
import Check from '@mui/icons-material/TaskAlt';

const SegmentedButtons = forwardRef(({ width = 400, labels = [], selectedValue, onChange, toggleRef }, ref) => {

    return (
        <div className={styles.segmentedButtons} ref={toggleRef} style={{width: width}}>
            {labels.map((label, index) => (
                <button
                    key={index}
                    className={styles.button}
                    onClick={() => onChange(label, index)}
                    disabled={label === selectedValue}
                >
                    <Check
                        sx={{
                            fontSize: 24,
                            marginRight: '4px',
                            color: label === selectedValue ? 'white' : 'transparent'
                        }}
                    />
                    {label}
                    <Check
                        sx={{
                            fontSize: 24,
                            marginRight: '4px',
                            color: 'transparent'
                        }}
                    />                    
                </button>
            ))}
        </div>
    );
});

export default SegmentedButtons;
